export const preferredEndpoints = {
    sei: {
        rpc: ['https://rpc.atlantic-2.seinetwork.io/'],
        rest: ['https://rest.atlantic-2.seinetwork.io/'],
    },
};
//# sourceMappingURL=config.js.map